import React from 'react';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  center?: boolean;
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  text,
  center = false,
  className = '',
}) => {
  // Size styles - border-2 is standard for all sizes
  const sizes = {
    sm: 'w-4 h-4 border-2',
    md: 'w-6 h-6 border-2',      // Changed from w-10 border-3
    lg: 'w-8 h-8 border-2',      // Changed from w-12 border-4
  };

  const spinnerElement = (
    <div className={center ? 'flex flex-col items-center' : ''}>
      <div
        className={`${sizes[size]} rounded-full border-neutral-200 border-t-primary-600 animate-spin ${className}`}
        role="status"
        aria-label={text || 'Loading'}
      />
      {text && (
        <p className="mt-4 text-sm font-medium text-neutral-600">{text}</p>
      )}
    </div>
  );

  if (center) {
    return (
      <div className="flex items-center justify-center p-12">
        {spinnerElement}
      </div>
    );
  }

  return spinnerElement;
};

Spinner.displayName = 'Spinner';
